import { render, staticRenderFns } from "./ExpandableTextarea.vue?vue&type=template&id=1129b60a&"
import script from "./ExpandableTextarea.vue?vue&type=script&lang=js&"
export * from "./ExpandableTextarea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports